import { AppBar, Toolbar, Typography, useTheme } from "@mui/material";
import React, { useContext } from "react";

import { updateFileCountContext } from "providers/uploadFileCount-provider";

import {
  getUploadProgressBannerAppBarSx,
  uploadProgressBannerToolbarSx,
} from "./styles";

export const UploadProgressBanner = () => {
  const { uploadedCount, totalCount } = useContext(updateFileCountContext);
  const theme = useTheme();

  if (totalCount === undefined || totalCount === 0) {
    return null;
  }

  return (
    <AppBar
      position="absolute"
      role="status"
      aria-live="polite"
      sx={getUploadProgressBannerAppBarSx(theme)}
    >
      <Toolbar variant="dense" sx={uploadProgressBannerToolbarSx}>
        <Typography align="center">
          File uploading {uploadedCount} of {totalCount}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};
